import global$1 from './global.js';
import toIntegerOrInfinity$1 from './to-integer-or-infinity.js';
import toLength$1 from './to-length.js';

var global = global$1;
var toIntegerOrInfinity = toIntegerOrInfinity$1;
var toLength = toLength$1;
var RangeError = global.RangeError; // `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex

var toIndex = function (it) {
  if (it === undefined) return 0;
  var number = toIntegerOrInfinity(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length or index');
  return length;
};

export { toIndex as default };
